import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "admin-home"
};
var _hoisted_2 = {
  class: "home-left"
};
var _hoisted_3 = {
  class: "home-right"
};
var _hoisted_4 = {
  class: "right-component"
};
import { onBeforeUnmount, markRaw, onMounted, ref, watch } from 'vue';
import TabNav from './Common/TabNav.vue';
import UserInfo from '../Common/UserInfo.vue';
import MessageNotice from '../Common/MessageNotice.vue';
import TodoList from '../Common/TodoList.vue';
import AppList from '../Common/AppList.vue';
import Course from './Course/index.vue';
import Objectives from './Objectives/index.vue';
import Activity from './Activity/index.vue';
import Evaluate from './Evaluate/index.vue';
import Chat from './Chat/index.vue';
import Note from './Note/index.vue';
import Typical from './Typical/index.vue';
import TimeTable from './TimeTable/index.vue';
import { getUnRead } from '@/api/home.js';
import { MessagePlugin } from 'tdesign-vue-next';
import { validateNull } from '@/util/validate';
import $Bus from '@/util/bus';
import { NOTIFY_UPDATA_EVENT, SHOW_NOTIFY_EVENT } from '@/const/busEvent.js';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var currentTabIndex = ref(0);
    var userTabs = ref([]);

    // 定义所有可能的导航项
    var allNavs = [{
      name: '课程学习',
      icon: 'course',
      alias: 'learnCentre',
      component: markRaw(Course)
    }, {
      name: "目标管理",
      icon: "course",
      alias: "objectivesMandate",
      component: markRaw(Objectives)
    }, {
      name: '活动课程',
      icon: 'activity',
      alias: 'activity',
      component: markRaw(Activity)
    }, {
      name: '自主管理',
      icon: 'evaluate',
      alias: 'comprehensiveEvaluate',
      component: markRaw(Evaluate)
    }, {
      name: '1V1辅导',
      icon: 'chat',
      alias: 'chatQa',
      component: markRaw(Chat)
    }, {
      name: '笔记',
      icon: 'note',
      alias: 'cloudNotes',
      component: markRaw(Note)
    }, {
      name: '典题本',
      icon: 'typical',
      alias: 'typicalExercises',
      component: markRaw(Typical)
    }, {
      name: '课表',
      icon: 'timetable',
      alias: 'stuTimeTable',
      component: markRaw(TimeTable)
    }];

    // 安全地获取并初始化tabs数据
    var initializeTabs = function initializeTabs() {
      try {
        var _userAppList$find;
        userTabs.value = [];
        var userAppList = getStore({
          name: 'userAppList',
          type: 'session'
        });

        // 如果userAppList不存在，先不处理，等待后续事件触发
        if (!userAppList) {
          console.log('userAppList 还未加载，等待AppList组件加载数据...');
          return;
        }
        var studentAppList = (userAppList === null || userAppList === void 0 || (_userAppList$find = userAppList.find(function (i) {
          return i.type === 'student';
        })) === null || _userAppList$find === void 0 ? void 0 : _userAppList$find.list) || [];
        console.log('studentAppList', studentAppList);
        var appNames = ['chatQa', 'objectivesMandate', 'activity', 'cloudNotes', 'learnCentre', 'typicalExercises', 'comprehensiveEvaluate', 'stuTimeTable'];

        // 安全地过滤和映射appAlias，确保每个item和item.appDetail都存在
        var appAlias = [];
        studentAppList.forEach(function (item) {
          try {
            if (item && item.appDetail && item.appDetail.alias && appNames.includes(item.appDetail.alias)) {
              appAlias.push(item.appDetail.alias);
            }
          } catch (e) {
            console.warn('处理studentAppList项时出错:', e);
          }
        });

        // 根据appAlias过滤tabs
        var filteredTabs = allNavs.filter(function (nav) {
          return appAlias.includes(nav.alias);
        });
        console.log('=======');
        console.log(filteredTabs);
        // 更新tabs
        userTabs.value = filteredTabs;
        console.log('userTabs已初始化:', userTabs.value);
      } catch (error) {
        console.error('初始化tabs时出错:', error);
        // 发生错误时清空tabs
        userTabs.value = [];
      }
    };
    onMounted(function () {
      initializeTabs();
      // 获取未读消息
      getUnReadRequset();

      // 添加事件监听
      addBusEvent();
    });
    onBeforeUnmount(function () {
      removeBusEvent();
    });

    /**
     * 添加事件监听
     */
    var addBusEvent = function addBusEvent() {
      $Bus.on(NOTIFY_UPDATA_EVENT, getUnReadRequset);
      // 监听应用列表更新事件
      $Bus.on('appListUpdated', initializeTabs);
    };

    /**
     * 移除事件监听
     */
    var removeBusEvent = function removeBusEvent() {
      $Bus.off(NOTIFY_UPDATA_EVENT, getUnReadRequset);
      // 移除应用列表更新事件监听
      $Bus.off('appListUpdated', initializeTabs);
    };

    /**
     * 获取未读消息
     */
    var getUnReadRequset = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, item, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getUnRead();
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0 && !validateNull(data)) {
                item = data[0];
                $Bus.emit(SHOW_NOTIFY_EVENT, item);
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function getUnReadRequset() {
        return _ref.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _userTabs$value$curre;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("aside", _hoisted_2, [_createVNode(UserInfo), _createVNode(MessageNotice), _createVNode(AppList, {
        role: "student"
      })]), _createElementVNode("section", _hoisted_3, [_createVNode(TabNav, {
        "current-index": currentTabIndex.value,
        "onUpdate:currentIndex": _cache[0] || (_cache[0] = function ($event) {
          return currentTabIndex.value = $event;
        }),
        items: userTabs.value
      }, null, 8, ["current-index", "items"]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent((_userTabs$value$curre = userTabs.value[currentTabIndex.value]) === null || _userTabs$value$curre === void 0 ? void 0 : _userTabs$value$curre.component)))])])]);
    };
  }
};